import React, { useMemo } from "react";
import { useParams } from "react-router-dom";

import ServiceDocsManager from "../service/components/ServiceDocsManager";
import { inspectionsConfig, INSPECTIONS_DOC_TYPE } from "./inspections.config";

export default function InspectionsAll() {
  const { companyId } = useParams();

  const registry = useMemo(() => {
    const cfg = inspectionsConfig({ companyId });
    return { [cfg.value]: cfg };
  }, [companyId]);

  const defaultDocType = {
    label: registry[INSPECTIONS_DOC_TYPE].label,
    value: INSPECTIONS_DOC_TYPE,
  };

  return <ServiceDocsManager companyId={companyId} registry={registry} defaultDocType={defaultDocType} />;
}
